// extracted by mini-css-extract-plugin
export default {"dashboard-title-container":"DashboardTitle_dashboard-title-container__k1Ewi","title":"DashboardTitle_title__3LqRZ"};